import React, { PureComponent } from 'react';
import { Drawer } from 'antd';

// import ShowModal from '../modal/showModal/ShowModal';
import DoorsAmount from './Fields/DoorsAmount';
import GarageNumber from './Fields/GarageNumber';
import Tachograph from './Fields/Tachograph';
import Gps from './Fields/Gps';
import DiagnosticCard from './Fields/DiagnosticCard';
import ContractOsgopp from './Fields/ContractOsgopp';
import Kasko from './Fields/Kasko';

import {
  destinationPopupContent,
  destinationPopupHeader,
} from './contentsForPopover';

class Section2 extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      distinationModalVisible: false,
    };
  }

  render() {
    const { distinationModalVisible } = this.state;
    const { disabled, form } = this.props;
    return (
      <div className="twoSectionArea">
        <div className="border-emmit"></div>
        <div className="aHeight-3"></div>
        {/* ПОЯСНЯЛКА */}
        <Drawer
          title={destinationPopupHeader}
          placement="left"
          width={896}
          closable={true}
          visible={distinationModalVisible}
          onClose={() =>
            this.setState((state, props) => ({
              distinationModalVisible: !state.distinationModalVisible,
            }))
          }
          className="infoAddVehicle"
        >
          {destinationPopupContent}
        </Drawer>
        {/*
        <div className="destinationArea">
          <span className="label">Назначение:</span>
          <Form.Item>
            {getFieldDecorator('assignment', configShort(undefined, false))(
              <Select
                mode="multiple"
                showArrow
                placeholder="Укажите назначение"
                dropdownClassName="select select_multiple serviceTypesDropdown"
                optionLabelProp="label"
                maxTagCount={0}
                className="basicInput"
                disabled={disabledAll}
              >
                {functionsTypes &&
                                    functionsTypes.map((func, index) => (
                                        <Option
                                            key={index}
                                            label={func.functionName}
                                            value={func.functionId}
                                        >
                                            {func.functionName}
                                        </Option>
                                    ))}
        </Select>
            )}
          </Form.Item>

          {disabledAll ? (
            <ShowModal title="Назначение" content={fields['assignment']} />
          ) : (
            <svg
              width="24"
              height="24"
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => this.setState({ distinationModalVisible: true })}
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 0C5.37187 0 0 5.37187 0 12C0 18.6281 5.37187 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37187 18.6281 0 12 0ZM19.2914 19.2914C18.3445 20.2383 17.2406 20.9836 16.0125 21.5016C14.7422 22.0406 13.3922 22.3125 12 22.3125C10.6078 22.3125 9.25781 22.0406 7.9875 21.5039C6.75938 20.9836 5.65781 20.2406 4.70859 19.2938C3.76172 18.3469 3.01641 17.243 2.49844 16.0148C1.95938 14.7422 1.6875 13.3922 1.6875 12C1.6875 10.6078 1.95938 9.25781 2.49609 7.9875C3.01641 6.75938 3.75938 5.65781 4.70625 4.70859C5.65312 3.76172 6.75703 3.01641 7.98516 2.49844C9.25781 1.95938 10.6078 1.6875 12 1.6875C13.3922 1.6875 14.7422 1.95938 16.0125 2.49609C17.2406 3.01641 18.3422 3.75938 19.2914 4.70625C20.2383 5.65312 20.9836 6.75703 21.5016 7.98516C22.0406 9.25781 22.3125 10.6078 22.3125 12C22.3125 13.3922 22.0406 14.7422 21.5039 16.0125C20.9836 17.2406 20.2406 18.3445 19.2914 19.2914ZM11.8781 15.5602C11.85 15.5602 11.8219 15.5578 11.7938 15.5555C11.3297 15.5109 10.9922 15.0961 11.0367 14.632C11.1516 13.4625 12.0094 12.518 12.9539 11.5734C14.4656 10.0617 14.4914 9.58125 14.5172 9.07266C14.5477 8.47969 14.3297 7.90547 13.8984 7.45312C13.4086 6.9375 12.7148 6.64219 11.9953 6.64219C11.993 6.64219 11.9906 6.64219 11.9906 6.64219C10.6055 6.64453 9.47578 7.77422 9.47578 9.16172C9.47578 9.62813 9.09844 10.0055 8.63203 10.0055C8.16563 10.0055 7.78828 9.62813 7.78828 9.16172C7.78828 8.03906 8.22422 6.98438 9.01641 6.18984C9.80859 5.39531 10.8633 4.95703 11.9859 4.95469C13.1695 4.95234 14.3133 5.43984 15.1219 6.29063C15.8742 7.08281 16.2586 8.10234 16.2023 9.16172C16.1437 10.2469 15.8109 11.1023 14.1469 12.7664C13.3031 13.6102 12.7711 14.243 12.7172 14.7984C12.675 15.2344 12.307 15.5602 11.8781 15.5602ZM10.8328 18.0281C10.8328 18.3907 11.0262 18.7257 11.3402 18.907C11.6542 19.0883 12.0411 19.0883 12.3551 18.907C12.6691 18.7257 12.8625 18.3907 12.8625 18.0281C12.8625 17.4676 12.4081 17.0133 11.8477 17.0133C11.2872 17.0133 10.8328 17.4676 10.8328 18.0281Z"
                fill="#00a8ff"
              />
            </svg>
          )}
        </div> */}
        <div className="treePopWrap">
          <DoorsAmount form={form} disabled={disabled} />
          <GarageNumber form={form} disabled={disabled} />
        </div>
        <div className="midWrap">
          <Tachograph form={form} disabled={disabled} />
          <Gps form={form} disabled={disabled} />
        </div>
        <div className="treeColWrap">
          <DiagnosticCard form={form} disabled={disabled} />
        </div>
        <div className="minWrap">
          <ContractOsgopp form={form} disabled={disabled} />
        </div>
        <div className="minWrap">
          <Kasko form={form} disabled={disabled} />
        </div>
      </div>
    );
  }
}

export default Section2;
